export default __webpack_public_path__ + "static/media/event_thumbnail_icon.8414d6a8.png";